import React, { useState, useEffect } from "react";
import { LabelContext } from "../../core/label.context";
import { IYounitedSplitPayment } from "../../common/cart.models";
import { GeneralContext } from "../../core/general.context";
import { CartContext } from "../../core/cart.context";
import { BRX_ASSETS_URL, CHECKOUT_PAYMENT_LOGOS } from "../../core/APIUtils";

export const YounitedSplitPayComponent = (props: any) => {
  const { t } = React.useContext(LabelContext);
  const { younited } = React.useContext(GeneralContext);
  const { getYounitedOffers } = React.useContext(CartContext);
  const {
    cartid,
    amount,
    redirectToYounitedSplitPay,
    setClickedPay,
    unmountAdyenComponents,
    selectedPaymentMethod,
    setSelectedPaymentMethod,
  } = props;

  const [selectedInstallment, setSelectedInstallment] = useState<number>(3);
  const [selectedOption, setSelectedOption] = useState<IYounitedSplitPayment | null>(null);
  const [isExpanded, setExpanded] = useState(false);

  const splitPayments: IYounitedSplitPayment[] = younited?.obj?.splitPayments || [];

  const svgStringWhite = `<svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 536.46 216.55"><defs><style>.cls-1{fill:#c5a1fe;}.cls-3{fill:#fff;}</style></defs><path id="Tracé_1111094-2" data-name="Tracé 1111094-2" class="cls-1" d="M277.73,96.64c0-20.66-16.61-36.29-37.05-37.9L83,45.8l21.35,29.64L47.83,96.64l56.51,21.19L83,147.47l157.69-12.94c20.44-2.06,37.05-17.25,37.05-37.89"/><g id="Groupe_38396-2" data-name="Groupe 38396-2"><path id="Tracé_1110999-8" data-name="Tracé 1110999-8" class="cls-3" d="M237.84,119.48c-14.38,0-21.68-6.93-21.68-20.6l-.46-24.56h13.7L229,97.54c0,6.37,3.37,10.16,9,10.16s9-3.57,9-9.79l-.45-23.58h13.7l-.46,24.17c0,14.13-7.18,21-21.95,21"/><path id="Tracé_1111000-8" data-name="Tracé 1111000-8" class="cls-3" d="M302.91,118.85,281.2,93.16l2,25.69H270.17V74.32h11.59l21,24.75-2.05-24.75h13.07v44.53Z"/><rect id="Rectangle_34108-8" data-name="Rectangle 34108-8" class="cls-3" x="324.33" y="74.45" width="12.79" height="44.52"/><path id="Tracé_1111001-8" data-name="Tracé 1111001-8" class="cls-3" d="M361.33,119V83.67l-14.05,1V74.46h40.9v10.2l-14.06-1V119Z"/><path id="Tracé_1111002-8" data-name="Tracé 1111002-8" class="cls-3" d="M397.68,119V74.45h37.55V84.8l-25-1v8.56h23.34v8.35H410.19v8.9l25.38-1V119Z"/><g id="Groupe_38307-8" data-name="Groupe 38307-8"><path id="Tracé_1111003-8" data-name="Tracé 1111003-8" class="cls-3" d="M461.77,74.45h-16.7V119h16.15c17.17,0,27.41-8.42,27.41-22.53v-.13C488.63,82.42,478.84,74.45,461.77,74.45Zm13.94,22.33c0,7.4-4.83,11.47-13.6,11.47h-4.25V85.18h4.25c8.77,0,13.6,4.07,13.6,11.47Z"/></g><path id="Tracé_1111004-8" data-name="Tracé 1111004-8" class="cls-3" d="M130.43,118.85l1-19.2L113.92,74.32H130l7.59,13.84,8-13.84h15.76L143.78,99.65l1.05,19.2Z"/><path id="Tracé_1111005-8" data-name="Tracé 1111005-8" class="cls-3" d="M184,119.66c-13.57,0-24.19-10.08-24.19-22.94v-.14c0-12.94,10.68-23.07,24.33-23.07s24.2,10.07,24.2,22.94v.14c0,12.94-10.69,23.07-24.34,23.07m0-35.19c-6.42,0-11.27,5.15-11.27,12v.14c0,6.91,4.9,12.12,11.41,12.12s11.27-5.16,11.27-12v-.13c0-6.91-4.9-12.12-11.41-12.12"/></g></svg>`;

  const toggleExpanded = async () => {
    setClickedPay(true);
    unmountAdyenComponents();
    await getYounitedOffers(cartid, amount);
    setExpanded(true);
    setSelectedPaymentMethod("younitedSplitPay");
  };

  useEffect(() => {
    if (splitPayments.length > 0) {
      const option = splitPayments.find((sp) => sp.installmentCount === selectedInstallment);
      setSelectedOption(option || splitPayments[0]);
    }
  }, [selectedInstallment, younited]);

  useEffect(() => {
    if (selectedPaymentMethod !== "younitedSplitPay") {
      setExpanded(false);
    }
  }, [selectedPaymentMethod]);

  const handleSubmit = () => {
    if (selectedOption) {
      redirectToYounitedSplitPay(selectedOption.installmentCount);
    }
  };

  return (
    <div>
      <div className="radio-item w-100">
        <input
          type="radio"
          id="younitedSplitPay-checkbox"
          name="paymentMethod"
          value="younitedSplitPay"
          checked={selectedPaymentMethod === "younitedSplitPay"}
          onClick={toggleExpanded}
        />
        <label htmlFor="younitedSplitPay-checkbox" className="btn-payment-methods">
          {t("ecommerce.younited.splitPayBtn")}
          {CHECKOUT_PAYMENT_LOGOS?.younited?.map((logo: string, i: number) => (
            <img key={i} className={"payment-icon pl-3"} src={`${BRX_ASSETS_URL}/images/icons/payments/footer/${logo}.svg`} alt={logo} title={logo} />
          ))}
        </label>
      </div>
      {isExpanded && splitPayments.length > 0 && (
        <div>
          <div className="splitPaymentsYounitedRadio">
            {splitPayments.map((sp) => (
              <div className="radio-item">
                <input
                  id={sp.installmentCount.toString()}
                  type="radio"
                  name="splitInstallment"
                  value={sp.installmentCount}
                  checked={selectedInstallment === sp.installmentCount}
                  onChange={() => setSelectedInstallment(sp.installmentCount)}
                />
                <label htmlFor={sp.installmentCount.toString()} key={sp.installmentCount}>
                  {' '}{sp.installmentCount}x
                </label>
              </div>
            ))}
          </div>
          <div className="splitPaymentsYounitedButton text-center">
            <button type="button" className="ec_btn_primary cmp_button" onClick={handleSubmit}>
              <span>{t("ecommerce.younited.payBtn")} {selectedOption?.installmentAmount.toFixed(2)} &euro;/{t("ecommerce.younited.month")}</span>
              <span className='btn-icon' dangerouslySetInnerHTML={{ __html: svgStringWhite }} />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
